import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/axios';
import { toast } from 'react-toastify';
import { EnvelopeIcon, ArrowLeftIcon, BriefcaseIcon } from '@heroicons/react/24/outline';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post('/auth/forgot-password', { email });
            toast.success("Reset link sent! Check your email.");
        } catch (err) {
            toast.error(err.response?.data?.error || "Failed to send link");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex bg-white">
            {/* Left Side Visuals */}
            <div className="hidden lg:flex w-1/2 bg-gray-900 relative items-center justify-center overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-indigo-900 to-gray-900 z-0"></div>
                <div className="absolute top-20 left-20 w-72 h-72 bg-primary rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>

                <div className="relative z-10 text-white text-center p-10">
                    <div className="bg-white/10 backdrop-blur-md p-4 rounded-2xl inline-flex items-center space-x-3 mb-6 border border-white/10">
                        <BriefcaseIcon className="h-8 w-8 text-indigo-300" />
                        <span className="text-2xl font-bold">SmartBreak</span>
                    </div>
                    <h2 className="text-4xl font-bold mb-4">Account Recovery</h2>
                    <p className="text-gray-300">Don't worry, it happens to the best of us.</p>
                </div>
            </div>

            {/* Right Side Form */}
            <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-white">
                <div className="w-full max-w-md">
                    <Link to="/" className="flex items-center text-sm text-gray-500 hover:text-primary mb-8 transition">
                        <ArrowLeftIcon className="h-4 w-4 mr-1" /> Back to Login
                    </Link>

                    <h2 className="text-3xl font-bold text-gray-900 mb-2">Forgot Password?</h2>
                    <p className="text-gray-500 mb-8">Enter your email and we'll send you instructions to reset your password.</p>

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-1">Email Address</label>
                            <div className="relative">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <EnvelopeIcon className="h-5 w-5 text-gray-400" />
                                </div>
                                <input
                                    type="email"
                                    required
                                    className="block w-full pl-10 pr-3 py-3 border border-gray-200 rounded-xl bg-gray-50 focus:bg-white focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition"
                                    placeholder="you@company.com"
                                    onChange={e => setEmail(e.target.value)}
                                />
                            </div>
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full py-3.5 px-4 rounded-xl shadow-lg text-sm font-medium text-white bg-primary hover:bg-indigo-700 transition transform hover:scale-[1.01]"
                        >
                            {loading ? "Sending..." : "Send Reset Link"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;